import { Link, Action, linkFields } from '../../core/Link';
import * as THREE from 'three';
import { forwardRef } from 'react';

// Create a reusable Video Link component
const VideoLinkComponent = forwardRef<THREE.Object3D, { properties: any; isPreview?: boolean }>((props, ref) => {
  // Video links don't have a visual representation, so we return null
  return null;
});

// Default action for video links
const defaultAction: Action = {
  id: crypto.randomUUID(),
  name: 'Video Tracking Action',
  type: 'minmax',
  targetItemId: '',
  targetProperty: '',
  range: {
    min: 0,
    max: 1
  },
  enabled: true,
  easing: 'linear',
  curve: 'linear'
};

export const VideoLinkItem: Link = {
  id: '',
  name: 'Video Link',
  type: 'link',
  linkType: 'video',
  icon: 'Video',
  settings: {
    videoSource: 'camera1',
    trackingTarget: 'person1'
  },
  actions: [defaultAction],
  properties: {
    enabled: true,
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 }
  },
  fields: [
    ...linkFields.common,
    ...linkFields.video
  ],
  render: (properties, isPreview, ref) => {
    return null; // Video links don't have a visual representation
  }
};
